import React from 'react';
import { Skeleton, Row, Col } from 'antd';

/**
 * Reusable page loading skeleton — shown during React.lazy chunk loading.
 * Mimics the layout of dashboard pages (stat cards + chart area).
 */
function PageSkeleton() {
  return (
    <div style={{ padding: '24px' }}>
      {/* Header skeleton */}
      <Skeleton.Input active size="large" style={{ width: 240, marginBottom: 24 }} />

      {/* Stat cards row */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        {[1, 2, 3, 4].map(i => (
          <Col span={6} key={i}>
            <div style={{
              padding: 16,
              borderRadius: 8,
              border: '1px solid var(--theme-border, #f0f0f0)',
              background: 'var(--theme-cardBg, #fff)',
            }}>
              <Skeleton active paragraph={{ rows: 2 }} title={false} />
            </div>
          </Col>
        ))}
      </Row>

      {/* Chart area skeleton */}
      <div style={{
        padding: 24,
        borderRadius: 8,
        border: '1px solid var(--theme-border, #f0f0f0)',
        background: 'var(--theme-cardBg, #fff)',
      }}>
        <Skeleton active paragraph={{ rows: 8 }} />
      </div>
    </div>
  );
}

export default PageSkeleton;
